import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { IHistoryEntry } from '../../../../hooks/useUndoRedo';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Undo } from '@mui/icons-material';
import { timestampToString } from '../../../../utils/formatUtils';

interface HistoryListEntryProps {
  entry: IHistoryEntry;
  hasHoverContext: boolean;
  isCurrent: boolean;
  isRedoStack: boolean;
  onEntryClick: () => void;
  onEntryHover: () => void;
}

const HistoryListEntry: React.FunctionComponent<HistoryListEntryProps> = ({ entry, hasHoverContext, isCurrent, isRedoStack, onEntryClick: onClick, onEntryHover }) => {
  const intl = useIntl();

  const styleSelected = useMemo(
    () => ({
      backgroundColor: '#eeeeee',
    }),
    [],
  );

  const styleRedoStack = useMemo(
    () => ({
      title: {
        opacity: 0.5,
      },
      listItem: { opacity: 0.6 },
    }),
    [],
  );

  return (
    <ListItem disablePadding onClick={onClick} onMouseEnter={onEntryHover} sx={isRedoStack ? styleRedoStack.listItem : {}}>
      <ListItemButton sx={{ display: 'flex', justifyContent: 'space-between', ...((isCurrent || hasHoverContext) && styleSelected) }}>
        <ListItemText primary={intl.formatMessage({ id: entry.action })} secondary={timestampToString(entry.timestamp)} sx={isRedoStack ? styleRedoStack.title : {}} />
        <ListItemIcon sx={{ justifyContent: 'center' }}>{isRedoStack && <Undo />}</ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
};

export default HistoryListEntry;
